import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NetworkConnectivityService {
  window: Window = window;
  constructor(private snackBar: MatSnackBar) {}

  checkForNetworkConnectivity(): boolean {
    return this.window?.navigator?.onLine;
  }

  listenForNetworkConnectivityChanges(): void {
    this.window?.addEventListener('online', () => {
      this.snackBar.open('You are online', 'Close', { duration: 3000 });
    });

    this.window?.addEventListener('offline', () => {
      this.snackBar.open('You are offline', 'Close', { duration: 0 });
    });
  }
}
